export const LOAD_ALL_ITEMS_START = 'INDEX.LOAD_ALL_ITEMS_START'
export const LOAD_ALL_ITEMS_SUCCESS = 'INDEX.LOAD_ALL_ITEMS_SUCCESS'
export const LOAD_ALL_ITEMS_FAILED = 'INDEX.LOAD_ALL_ITEMS_FAILED'

export const LOAD_INDEX_CLEAR = 'LOAD_INDEX_CLEAR'
export const LOAD_INDEX_START = 'INDEX.LOAD_INDEX_START'
export const LOAD_INDEX_SUCCESS = 'INDEX.LOAD_INDEX_SUCCESS'
export const LOAD_INDEX_FAILED = 'INDEX.LOAD_INDEX_FAILED'

export const LOAD_DAILY_DATA_START = 'INDEX.LOAD_DAILY_DATA_START'
export const LOAD_DAILY_DATA_SUCCESS = 'INDEX.LOAD_DAILY_DATA_SUCCESS'
export const LOAD_DAILY_DATA_FAILED = 'INDEX.LOAD_DAILY_DATA_FAILED'
export const LOAD_DAILY_DATA_CLEAR = 'INDEX.LOAD_DAILY_DATA_CLEAR'